var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWhy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 233.16 269.41",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#b4c1d5;}.cls-2{fill:#664e3e;}.cls-3{fill:#002d55;}.cls-4{fill:#ffb452;}.cls-5{fill:#6cabce;}.cls-6{fill:#ffa895;}.cls-7{fill:#3f352d;}.cls-8{fill:#ff807d;}.cls-9{fill:#d6561e;}.cls-10{fill:#51443a;}.cls-11{fill:#ffd766;}.cls-12{fill:#ff6c22;}.cls-13{fill:#698daf;}.cls-14{fill:#7a5f4a;}.cls-15{fill:#5179a5;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "startseite"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m206.38,251.51s-27.95-14.85-29.72-46.27c-1.77-31.42,57.06-58.3,56.49-93.69-.57-35.4-75.2-33.2-56.53-60.43,13.14-19.17.92-38.92-54.87-49.06-75.31-13.69-32.31,44.38-31.99,71.8.33,27.42-107.92,81.46-54.43,177.65h171.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m131.63,225.42c15.65.95,31.3-6.11,45.42-16.26,3.74,28.73,29.34,42.35,29.34,42.35H35.33c-22.62-39.74-18.08-74.07,2.62-107.13,40.37,15.7,52.23,78.52,93.68,81.04Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-3",
    cx: 126.26,
    cy: 253.92,
    rx: 104.04,
    ry: 15.49
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m38.25,59.27l-11.42-5.25,27.15-20.5s7.99,3.76,10.15.55c2.16-3.21-3.84-10.8-3.84-10.8l-5.82,3.76s-32.06,15.83-34.92,17.88c-5.76,4.11-15.19,12.96,16.36,31.32l2.34-16.96Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m60.3,23.27l-3.21,2.07c.61,3.54,2.17,6.78,3.7,10.02,1.4.04,2.66-.28,3.35-1.29,2.16-3.21-3.84-10.8-3.84-10.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "m60.9,32.84s-3.71-11.41,3.07-13.4c0,0,12.87-8.23,22.32.41,0,0,3.58-.68,5.53.5l-2.12,1.04s2.17,2.82,1.85,8.77c-.32,5.96-1.99,16.99-12.47,19.29-10.49,2.31-18.17-16.61-18.17-16.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m72.65,37.38c-4.83-1.86-9.73-5.07-12.64-9.36-.02,0-.03,0-.05,0,.23,2.63.94,4.83.94,4.83,0,0,7.69,18.92,18.17,16.61,6.28-1.38,9.38-5.89,10.94-10.56-5.33,1.31-10.96.94-17.37-1.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "m67.91,57.14s-9.47,2.17-16.78,1.99c-7.32-.18-12.68-1.25-12.68-1.25l-2.84,20.63,18.11,2.72,14.19-24.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "m79.84,55.95s13.36,4.25,20.36,12.83c5.24,6.42,16.45,25.86,16.45,25.86l-15.43,8.59-10.58-23.18-10.79-24.09Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "94.4 131.63 94.4 238.54 83.4 240.3 81.81 200.78 74.32 157.92 70.97 157.92 62.69 198.71 55.2 239.34 44.38 235.8 51.54 129.56 94.4 131.63"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m51.06,136.63s19.28,11.57,43.34,7.91v-12.91l-43.34-3.03v8.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "m79.84,55.95l15.71,21.87.89,19.65,1.3,35.28s-27.72,9.72-49.71-1.59l3.24-54.18,16.04-19.59,12.53-1.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m67.12,26.19l-4.63,1.91s-6.69,14.3,2.4,22.01c1.39,1.18,2.91.66,2.91.66l-1.4,8.4s4.76,4.76,13.43,0v-11.75s6.16,1.83,6.44-2.72c.28-4.56-4.2-4-5.04-3.16,0,0-2.52-7.56.84-13.43,0,0-17.4,2.26-18.11,1.7-.72-.56,3.15-3.62,3.15-3.62Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "67.81 50.77 76.31 49.26 67.12 54.88 67.81 50.77"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m92.51,238.84l.77,11.33s12.59,2.07,13.54,7.49h-20.55l-1.44-17.59,7.68-1.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m93.28,250.17s12.59,2.07,13.54,7.49h-20.55l-.55-6.71c3.91,1.73,7.56-.78,7.56-.78Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "92.51 238.84 85.22 244.92 84.83 240.07 92.51 238.84"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m45.96,236.31l-.49,13.86s-12.59,2.07-13.54,7.49h20.55l1.44-17.59-7.97-3.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m45.47,250.17s-12.59,2.07-13.54,7.49h20.55l.55-6.71c-3.91,1.73-7.56-.78-7.56-.78Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "45.96 236.31 53.53 244.92 54.02 238.95 45.96 236.31"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "74.32 157.92 68.43 150.27 70.97 157.92 74.32 157.92"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "83.06 236.31 94.4 230.58 94.4 234.87 83.06 236.31"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "56.08 235.77 56.88 230.24 44.38 232.81 56.08 235.77"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m115.32,95.37s6.17,16.84,6.17,21.16-28.5,30.07-28.5,30.07l-2.16-5.5,17.88-25.55-5.32-13.54,11.93-6.64Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "108.71 115.55 111.42 112.56 108.13 114.05 108.71 115.55"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "103.4 102.01 115.32 95.37 104.5 104.81 103.4 102.01"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "96.2 92.25 94.89 83.91 98.58 97.46 96.2 92.25"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "38.25 59.27 35.92 76.23 29.6 72.33 38.25 59.27"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "26.84 54.02 25.56 52.42 33.43 49.04 26.84 54.02"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "51.04 80.83 51.76 73.27 48.03 80.37 51.04 80.83"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "95.82 234.72 95.82 238.84 82.29 240.62 80.85 236.31 95.82 234.72"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "58.23 236.31 56.32 240.62 42.48 236.31 42.48 232.33 58.23 236.31"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m93.76,149.01c-.11,0-.22-.06-.29-.16-1.73-2.73-3.58-9.74-3.66-10.04-.05-.18.06-.37.24-.42.19-.04.37.06.42.25.02.07,1.9,7.21,3.57,9.85.1.16.05.37-.11.47-.06.04-.12.05-.18.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "m72.89,61.28s6.63-9.42,11.06-7.26c4.43,2.16-.33,7.4-11.06,7.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "m73.12,62.73s-5.44-10.15-10.1-8.54c-4.66,1.61-.57,7.38,10.1,8.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m84.26,58.37c-.49.86-1.3,1.52-2.16,2.02-.87.51-1.82.83-2.79,1.05-.97.22-1.96.29-2.94.27-.49-.02-.98-.07-1.46-.12-.48-.11-.96-.18-1.44-.32.97-.14,1.92-.25,2.86-.36.93-.15,1.86-.25,2.76-.48.91-.19,1.8-.44,2.67-.77.85-.35,1.72-.72,2.5-1.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m61.97,58.24c.69.76,1.53,1.29,2.37,1.76.85.46,1.75.82,2.68,1.1.92.31,1.89.48,2.86.69l2.99.49c-.5.12-1.01.17-1.52.26-.51.03-1.03.06-1.55.05-1.03-.05-2.07-.18-3.08-.5-1-.32-1.97-.76-2.81-1.41-.84-.63-1.57-1.46-1.93-2.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "m176.53,37.2s-9.13-8.32-18.89.99c0,0-2.69,1.15-4.61,3.72-.02-.89-.42-1.82-2.24-1.4,0,0-4.95-4.55-7.73-.11-2.78,4.44-1.42,13.73,8.24,9.18,0,0,.01,0,.02,0,.07.39.26.77.26,1.2,0,8.74,4.43,11.72,11.21,12.45,6.78.72,16.07-15.62,16.07-15.62,0,0,2.92-7.52-2.33-10.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m152.13,55.45c1.37,5.19,5.27,7.21,10.66,7.78,6.78.72,16.07-15.62,16.07-15.62,0,0,.11-.29.25-.76-8.03,5.95-16.94,9.74-26.98,8.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m194.26,92.89l-10.95-20.01c-14.95,5.92,4.55,27.2,4.55,27.2,9.82,10.17,14.26,8.96,14.26,8.96l-7.86-16.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m157.13,236.58l-2.94,10.36-.74,7.55-18.61,3.03s-.27-4.43,5.59-5.69c4.62-.99,7.8-5.15,7.8-5.15v-10.29s8.89.19,8.89.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m148.24,246.69v-10.29s8.89.19,8.89.19l-2.94,10.36s-2.97,4.1-5.96-.26Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "156.16 240 148.23 236.4 157.13 236.58 156.16 240"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m196.2,232.53c.79-1.85-.13-7.39-.13-7.39l-7.67-96.15-8.52-1.04-26.46,1.5s-2.88,1.23-4.15,11.2c-2.26,17.73-2.85,63.76-3.45,84.25-.06,2.18-.86,7.17.41,9.35.37.63,2.01,2.15,2.01,2.15l8.9.19s2.5-.72,2.66-1.31c.67-2.56.84-9.84.84-9.84l10.39-71.74,3.37.05,8.2,73.46s.12,6.03,1.29,7.74c.34.5,1.94,1.61,1.94,1.61l8.75-1.61s1.36-1.75,1.65-2.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m188.53,130.7l-.14-1.71-8.52-1.04-26.46,1.5s-1.9.82-3.3,6.48c12.99,1.03,26.18-.72,38.42-5.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m188.53,92.69c1-4.94-6.4-20.38-6.4-20.38,0,0-4.43-2.83-8.56-3.42-4.13-.59-12.39,0-12.39,0l-2.56.44s-10.12,4.63-10.95,5.55l5.13,27.18-.48,13.44-1.78,15.18s26.38,4.88,39.96.05c0,0-6.19-17.22-1.97-38.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m157.81,72.16c2.19,1.73,5.15,2.08,7.88,2.24,4.71.29,9.44-.77,12.84-3.98-1.48-.66-3.24-1.29-4.96-1.53-4.13-.59-12.39,0-12.39,0l-2.56.44s-1.04.48-2.48,1.15c.52.62,1.07,1.2,1.67,1.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m185.8,236.56l4.56,9.76,1.95,7.33h18.86s-.45-4.41-6.44-4.71c-4.72-.24-8.53-3.83-8.53-3.83l-1.65-10.16-8.75,1.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m196.2,245.1l-1.65-10.16-8.75,1.61,4.56,9.76s3.59,3.56,5.84-1.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m171.12,63.27l1.27,5.57s-3.67,3.57-10.7,0l-.14-10.01s-6.37-.75-6.37-5.44c0-3.84,4.04-3.93,5.3-.03,0,0,2.28-2.64.9-8.05,0,0,13.17,2.05,16.09-2.97,0,0,2.1,4.83,1.82,12.08-.28,7.25-1.87,8.04-4.34,8.76-1.26.36-3.82.08-3.82.08Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "171.19 63.29 164.81 61.74 172.05 67.38 171.19 63.29"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "187.3 239.77 194.55 234.94 185.8 236.56 187.3 239.77"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m147.66,74.88c7.69,4.25,5.58,15.22-2.72,25.28l-9.07,12.69,11.49,20.53s.11-2.42,1.32-4.57c1.21-2.15,6.99-3.36,6.99-3.36v6.51l-3.9,3.67s-.13,2.73-2.02,5.28c-1.88,2.55-4.17,0-4.17,0,0,0-19.09-20.31-20.48-28.56-1.01-6,17.33-31.77,22.56-37.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m185.52,73.12c0-1.83-1.95-4.69-1.95-4.69,0,0-3.92-6.67-4.52-6.22-.6.44,1.07,5.36.72,5.8-.35.43-2.24,1.97-1.98,2.98.24.94,3.53,4.83,3.98,5.36,0,0,17.07,44.13,22.94,29.93,3.12-7.56-17.05-30.63-19.19-33.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m148.67,128.8c-1.21,2.15-1.32,4.57-1.32,4.57l-1.98-3.54c-.83,2.49-1.98,4.94-3.15,7.37,2,2.26,3.36,3.7,3.36,3.7,0,0,2.29,2.55,4.17,0,1.88-2.55,2.02-5.28,2.02-5.28l3.9-3.67v-6.51s-5.78,1.21-6.99,3.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m177.79,70.98c.24.94,3.53,4.83,3.98,5.36,0,0,.28.74.79,1.98.38-.33.76-.66,1.13-1,1.01-.93,1.92-1.99,2.89-2.97-.49-.58-.86-1-1.06-1.24,0-1.83-1.95-4.69-1.95-4.69,0,0-3.92-6.67-4.52-6.22-.6.44,1.07,5.36.72,5.8-.35.43-2.24,1.97-1.98,2.98Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "150.69 90.93 148.63 81.11 148.03 95.99 150.69 90.93"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m182.56,78.33l6.05,13.59s-5.93-7.67-6.05-13.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m227.15,28.74c-2.39-11.48-14.11-20.51-25.98-18.74-8.7,1.29-15.6,8.1-17.84,15.64-2.44,8.2.48,17.81,6.17,24.38l-4.23,6.9,9.9-2.01c2.92,1.81,6.19,2.89,9.62,2.92,12.87.09,25.37-14.64,22.36-29.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m191.98,23.5c1.4-1.83,3.01-3.29,4.82-4.37,1.82-1.08,3.79-1.69,5.92-1.83,1.42-.09,2.76.01,4.02.3,1.26.29,2.37.78,3.32,1.46.96.68,1.73,1.55,2.33,2.59.59,1.05.94,2.3,1.03,3.75.06.94-.06,1.77-.36,2.48-.3.72-.68,1.38-1.14,1.98-.46.6-.97,1.14-1.53,1.62-.56.48-1.07.92-1.54,1.34-.47.42-.87.83-1.19,1.23-.32.41-.46.82-.44,1.25l.15,2.35-7.89.49-.26-3.41c-.06-.97.23-1.87.88-2.71.65-.84,1.38-1.62,2.19-2.34.81-.72,1.55-1.4,2.23-2.02.67-.63.99-1.24.96-1.84-.02-.4-.14-.72-.34-.96-.2-.24-.46-.44-.76-.57-.31-.14-.66-.22-1.04-.26-.39-.03-.77-.04-1.14-.01-.46.03-.93.16-1.41.39-.49.23-.97.53-1.44.9-.48.37-.92.78-1.34,1.22-.42.44-.79.88-1.14,1.33l-4.9-4.36Zm6.71,20.3c-.03-.54.04-1.09.22-1.64.18-.55.47-1.06.87-1.51.4-.45.89-.83,1.47-1.14.58-.31,1.25-.49,2.02-.53.77-.05,1.46.03,2.09.23.63.2,1.18.5,1.66.88.48.38.86.85,1.14,1.38.28.54.43,1.11.47,1.7.07,1.19-.32,2.25-1.17,3.18-.86.92-2.07,1.44-3.63,1.53-.68.04-1.33-.05-1.94-.26-.61-.22-1.15-.51-1.62-.88-.47-.37-.84-.81-1.11-1.32-.27-.51-.43-1.05-.47-1.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m.38,100.52c2.03-9.73,11.96-17.38,22.02-15.88,7.37,1.1,13.22,6.87,15.12,13.26,2.07,6.95-.41,15.09-5.23,20.66l3.58,5.85-8.39-1.7c-2.48,1.54-5.24,2.45-8.15,2.47-10.9.07-21.5-12.41-18.95-24.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m8.8,96.62c1.18-1.55,2.55-2.78,4.09-3.7,1.54-.92,3.21-1.44,5.02-1.55,1.2-.08,2.34.01,3.41.26,1.07.25,2.01.66,2.82,1.24.81.58,1.47,1.31,1.97,2.2.5.89.79,1.95.87,3.18.05.8-.05,1.5-.3,2.11-.25.61-.57,1.17-.97,1.68-.39.51-.82.96-1.29,1.37-.47.4-.91.78-1.31,1.13-.4.35-.74.7-1.01,1.04-.27.34-.39.7-.37,1.06l.12,1.99-6.69.42-.22-2.89c-.05-.82.2-1.58.75-2.3.55-.71,1.17-1.37,1.85-1.98.69-.61,1.32-1.18,1.89-1.71.57-.53.84-1.05.81-1.56-.02-.34-.12-.61-.29-.82-.17-.21-.39-.37-.65-.49-.26-.12-.56-.19-.88-.22-.33-.03-.65-.03-.96-.01-.39.02-.78.13-1.2.33-.41.2-.82.45-1.22.77-.4.32-.78.66-1.13,1.03-.35.37-.67.75-.96,1.13l-4.15-3.7Zm5.69,17.21c-.03-.46.03-.92.18-1.39.15-.47.4-.9.74-1.28.34-.38.75-.71,1.25-.97.49-.26,1.06-.41,1.71-.45.65-.04,1.24.03,1.77.2.53.17,1,.42,1.41.75.41.33.73.72.96,1.17.23.46.37.94.4,1.44.06,1.01-.27,1.91-.99,2.69-.73.78-1.75,1.22-3.08,1.3-.58.04-1.13-.04-1.65-.22-.52-.19-.98-.43-1.37-.75-.39-.31-.71-.69-.94-1.12-.23-.43-.36-.89-.39-1.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m126.93,60.41c1.06-5.1,6.26-9.1,11.53-8.32,3.86.57,6.92,3.6,7.92,6.94,1.08,3.64-.21,7.9-2.74,10.82l1.88,3.06-4.4-.89c-1.3.8-2.75,1.28-4.27,1.29-5.71.04-11.26-6.5-9.93-12.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m131.34,58.36c.62-.81,1.33-1.46,2.14-1.94.81-.48,1.68-.75,2.63-.81.63-.04,1.23,0,1.79.14.56.13,1.05.35,1.48.65.42.3.77.69,1.03,1.15.26.47.42,1.02.46,1.66.03.42-.03.78-.16,1.1-.13.32-.3.61-.51.88-.21.27-.43.51-.68.72-.25.21-.48.41-.69.59-.21.18-.39.37-.53.55-.14.18-.21.36-.19.55l.07,1.04-3.5.22-.11-1.51c-.03-.43.1-.83.39-1.2.29-.37.61-.72.97-1.04.36-.32.69-.62.99-.9.3-.28.44-.55.42-.82-.01-.18-.06-.32-.15-.43-.09-.11-.2-.19-.34-.25-.14-.06-.29-.1-.46-.11-.17-.01-.34-.02-.5,0-.2.01-.41.07-.63.17-.22.1-.43.24-.64.4s-.41.35-.59.54c-.18.2-.35.39-.5.59l-2.17-1.94Zm2.98,9.01c-.01-.24.02-.48.1-.73.08-.25.21-.47.39-.67s.39-.37.65-.51c.26-.14.56-.22.9-.24s.65.01.93.1c.28.09.52.22.74.39.21.17.38.38.5.61.12.24.19.49.21.76.03.53-.14,1-.52,1.41-.38.41-.92.64-1.61.68-.3.02-.59-.02-.86-.12s-.51-.23-.72-.39c-.21-.16-.37-.36-.49-.59-.12-.23-.19-.47-.21-.72Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhy);
export default __webpack_public_path__ + "static/media/why.32935473eda83ca962c3c91fbc1d188b.svg";
export { ForwardRef as ReactComponent };